// 휴대폰 번호 입력·전송 정규화 — 서버 계약(`^01[016789]\d{7,8}$`, 숫자만)에 맞춘다.
//
// 왜 한 곳인가: 폼마다 각자 처리하면 새 폼이 생길 때 빠지고, 실제로 그렇게 빠져서
// 하이픈이 섞인 값이 서버까지 가 400으로 거절됐다(화면은 멀쩡해 보여 원인을 못 찾는다).
// 입력란은 `normalizePhoneInput`으로 **보이는 값 자체를 숫자만** 유지하고, 전송 경계는
// 같은 규칙을 한 번 더 적용해 다른 경로에서 들어온 값도 받아낸다.

/** 휴대폰 번호 최대 자릿수(010-1234-5678 = 11자리). */
export const PHONE_MAX_DIGITS = 11;

/**
 * 입력란용 — 숫자만 남기고 최대 자릿수에서 자른다.
 *
 * 보이는 값을 그대로 두고 전송할 때만 바꾸면 **화면과 전송 값이 어긋난다**. 사용자가 하이픈을
 * 넣었는데 아무 반응이 없으면 "입력이 되긴 됐다"고 믿게 되므로, 타이핑 시점에 걸러 낸다.
 */
export function normalizePhoneInput(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
}

/** 전송 경계용 — 값이 없으면 건드리지 않는다(memberId 경로는 phone을 쓰지 않는다). */
export function normalizePhoneForSubmit(phone: string | undefined): string | undefined {
  if (!phone) return phone;
  return phone.replace(/\D/g, '');
}

/**
 * 신원 키로 쓰려면 형식까지 맞아야 한다 — 서버 DTO(`@Matches(^01[016789]\d{7,8}$)`)와 같은 규칙.
 * 하이픈 등은 걷어내고 판정한다(입력란이 이미 숫자만 유지하지만, 다른 경로에서 온 값도 받아낸다).
 * (종전엔 `ApproverContactFormModal`이 자기 정규식을 들고 있었다 — 파일 머리의 「한 곳」 선언대로 옮김, 라운드 6.)
 */
export function isValidIdentityPhone(phone: string | undefined): boolean {
  return /^01[016789]\d{7,8}$/.test((phone ?? '').replace(/\D/g, ''));
}
